import { Button, Grid, Stack, Typography } from '@mui/material'
import { t } from 'i18next'
import Lottie from 'lottie-react'
import { useNavigate } from 'react-router'
import animationData from '../../components/Appointment/assets/lottie/notFound.json'

const NotFound = () => {
  const navigate = useNavigate()

  const onGoHome = () => {
    navigate('/')
  }

  return (
    <Grid container textAlign={'center'} spacing={1}>
      <Grid item xs={12}>
        <Lottie animationData={animationData} loop={false} style={{ height: '12rem' }} />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h1" p={1}>
          {t('pages.notFound.message')}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Stack direction={'row'} spacing={2} justifyContent={'center'} alignItems={'center'}>
          <Button onClick={onGoHome} variant="contained">
            {t('pages.notFound.action')}
          </Button>
        </Stack>
      </Grid>
    </Grid>
  )
}

export { NotFound }
